import { IQuoteSection } from 'types/quote'
import InfoArea from './InfoArea'

const Fourth = ({ quoteInfo }: IQuoteSection) => {
    return (
        <div className='bg-white border-[#9D9EB7] border-1 rounded-lg'>
            <div className='bg-[#F8F8FA] px-10 py-6 rounded-t-lg'>
                <p className='font-semibold first-line:text-2xl'>운송 정보</p>
            </div>

            <div className='flex flex-col gap-6 px-10 py-6'>
                {
                    quoteInfo.step2?.shipmentMode &&
                    <InfoArea
                        title='화물종류'
                        value={quoteInfo.step2?.shipmentMode}
                    />
                }
                {
                    quoteInfo.step2?.warehouseRequired &&
                    <InfoArea
                        title='창고작업'
                        value={quoteInfo.step2?.warehouseRequired ? '예' : '아니오'}
                    />
                }
                <InfoArea
                    title='내륙 운송 대행'
                    value={
                        quoteInfo.step2?.inlandAddress ?
                            `${quoteInfo.step2?.inlandAddress} ${quoteInfo.step2?.inlandAddressDetail}` :
                            '없음'
                    }
                />
            </div>
        </div >
    )
}

export default Fourth